module.exports = __webpack_public_path__ + "static/media/jack.29fc05ba.svg";